export default "__VITE_ASSET__3c4bf6d4__"